import yachtJaguar72 from "@/assets/yacht-jaguar72.webp";
import yachtPershing54 from "@/assets/yacht-pershing54.webp";
import yachtPershing54Exterior from "@/assets/yacht-pershing54-exterior.webp";
import yachtPershing54Aerial from "@/assets/yacht-pershing54-aerial.webp";
import yachtPershing54Stern from "@/assets/yacht-pershing54-stern.webp";
import yachtPardo43 from "@/assets/yacht-pardo43.webp";
import yachtPardo43Aerial from "@/assets/yacht-pardo43-aerial.webp";
import yachtPardo43Lifestyle from "@/assets/yacht-pardo43-lifestyle.webp";
import yachtPardo43Interior from "@/assets/yacht-pardo43-interior.webp";
import yachtKumbra43 from "@/assets/yacht-kumbra43.webp";
import yachtDeantonio42 from "@/assets/yacht-deantonio42.webp";
import yachtDeantonio42Hero from "@/assets/yacht-deantonio42-hero.webp";
import yachtDeantonio42Aerial from "@/assets/yacht-deantonio42-aerial.webp";
import yachtPardo38 from "@/assets/yacht-pardo38.webp";
import yachtPardo38Aerial from "@/assets/yacht-pardo38-aerial.webp";
import yachtPardo38Lifestyle from "@/assets/yacht-pardo38-lifestyle.webp";
import yachtPardo38Interior from "@/assets/yacht-pardo38-interior.webp";
import yachtKumbra36 from "@/assets/yacht-kumbra36.webp";
import yachtDeantonio36 from "@/assets/yacht-deantonio36.webp";
import yachtDeantonio36Aerial from "@/assets/yacht-deantonio36-aerial.webp";
import yachtDeantonio36Exterior from "@/assets/yacht-deantonio36-exterior.webp";
import yachtKumbra34Enjoy from "@/assets/yacht-kumbra.webp";
import yachtKumbra34Aerial from "@/assets/yacht-kumbra34-aerial.webp";
import yachtKumbra34Deck from "@/assets/yacht-kumbra34-deck.webp";
import yachtKumbra34Lifestyle from "@/assets/yacht-kumbra34-lifestyle.webp";
import yachtDeantonio33 from "@/assets/yacht-deantonio33.webp";
import yachtDeantonio33Aerial from "@/assets/yacht-deantonio33-aerial.webp";
import yachtDeantonio33Lifestyle from "@/assets/yacht-deantonio33-lifestyle.webp";
import yachtFim340 from "@/assets/yacht-fim340.webp";
import yachtFim340Exterior from "@/assets/yacht-fim340-exterior.webp";
import yachtFim340Deck from "@/assets/yacht-fim340-deck.webp";
import yachtFim340Interior from "@/assets/yacht-fim340-interior.webp";
import yachtCapCamarat from "@/assets/yacht-capcamarat.webp";
import yachtCapCamaratAerial from "@/assets/yacht-capcamarat-aerial.webp";
import yachtCapCamaratLifestyle from "@/assets/yacht-capcamarat-lifestyle.webp";
import yachtCapCamaratDeck from "@/assets/yacht-capcamarat-deck.webp";
import yachtSeaRay295 from "@/assets/yacht-searay295.webp";
import yachtSeaRay295Lifestyle from "@/assets/yacht-searay295-lifestyle.webp";
import yachtSeaRay295Interior from "@/assets/yacht-searay295-interior.webp";
import yachtSeaRay295Exterior from "@/assets/yacht-searay295-exterior.webp";
import yachtSaxdor270 from "@/assets/yacht-saxdor270.webp";
import yachtSaxdor270Aerial from "@/assets/yacht-saxdor270-aerial.webp";
import yachtSaxdor270Lifestyle from "@/assets/yacht-saxdor270-lifestyle.webp";
import yachtSaxdor270Deck from "@/assets/yacht-saxdor270-deck.webp";

export interface YachtPricing {
  low: string;
  mid: string;
  high: string;
}

export interface Yacht {
  slug: string;
  name: string;
  boatName: string;
  image: string;
  images?: string[];
  length: string;
  guests: string;
  cabins: string;
  cruisingSpeed: string;
  crew: string;
  features: string;
  marina: string;
  pricing: YachtPricing;
  priceNote: string;
  includes: string[];
  description: string;
}

import { charterFleet } from "./charter-fleet";

// Helper to parse price string to number for sorting
function parsePrice(price: string): number {
  return parseInt(price.replace(/[^0-9]/g, ""), 10) || 0;
}

const arzaniFleet: Yacht[] = [
  {
    slug: "sea-ray-295",
    name: "Sea Ray 295",
    boatName: "Infinity",
    image: yachtSeaRay295,
    images: [yachtSeaRay295, yachtSeaRay295Exterior, yachtSeaRay295Lifestyle, yachtSeaRay295Interior],
    length: "29 ft / 8.8 m",
    guests: "Up to 8 guests",
    cabins: "1",
    cruisingSpeed: "24 knots",
    crew: "Captain",
    features: "Cockpit seating, swim platform, cabin lounge",
    marina: "Marina Botafoc",
    pricing: { low: "€600", mid: "€700", high: "€800" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description: "The Sea Ray 295 is a timeless luxury cruiser designed for relaxed and comfortable days on the water. Its spacious cockpit offers generous seating for social gatherings while enjoying the ocean breeze. Below deck, the inviting cabin provides a quiet retreat between swims and coastal stops. With smooth performance and classic styling, the Sea Ray 295 delivers a welcoming boating experience.",
  },
  {
    slug: "cap-camarat-90",
    name: "Cap Camarat 9.0 WA",
    boatName: "Thymar",
    image: yachtCapCamarat,
    images: [yachtCapCamarat, yachtCapCamaratAerial, yachtCapCamaratLifestyle, yachtCapCamaratDeck],
    length: "30 ft / 9 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Bow sunbeds, spacious cockpit, swim ladder",
    marina: "Marina Botafoc",
    pricing: { low: "€650", mid: "€750", high: "€900" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description: "The Cap Camarat 9.0 WA offers a perfect combination of sporty performance and refined comfort. Its spacious cockpit and forward sunbeds provide inviting areas for relaxing under the sun. The thoughtfully designed cabin offers a cool and comfortable retreat during longer cruises. Ideal for coastal adventures, it delivers versatility and luxury in equal measure.",
  },
  {
    slug: "saxdor-270",
    name: "Saxdor 270 GTO",
    boatName: "Leo",
    image: yachtSaxdor270,
    images: [yachtSaxdor270, yachtSaxdor270Aerial, yachtSaxdor270Lifestyle, yachtSaxdor270Deck],
    length: "27 ft / 8.4 m",
    guests: "Up to 7 guests",
    cabins: "Day cabin",
    cruisingSpeed: "35 knots",
    crew: "Captain",
    features: "Sport performance hull, sunbeds, social cockpit",
    marina: "Port Nàutic",
    pricing: { low: "€650", mid: "€750", high: "€900" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Snorkels", "Beverages", "Towels"],
    description: "The Saxdor 270 GTO combines innovative design with thrilling performance for a modern luxury boat charter. Its sleek hull and powerful engines deliver speed and agility while maintaining smooth handling. The open deck layout creates a vibrant social atmosphere with comfortable seating and sunbathing areas. Compact yet sophisticated, the Saxdor 270 GTO offers an exciting and stylish day on the water.",
  },
  {
    slug: "fim-340",
    name: "FIM Regina 340",
    boatName: "Éxito",
    image: yachtFim340,
    images: [yachtFim340, yachtFim340Exterior, yachtFim340Deck, yachtFim340Interior],
    length: "34 ft / 10.4 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Italian design, sunbeds, luxury seating areas",
    marina: "Marina Botafoc",
    pricing: { low: "€900", mid: "€1,000", high: "€1,300" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The FIM 340 reflects the elegance and craftsmanship of Italian luxury yacht design. Sculpted lines and premium materials create an atmosphere of understated sophistication. Generous lounge areas and sunbeds make it ideal for relaxing and entertaining guests while cruising. Every journey aboard the FIM 340 is defined by comfort, style, and refined performance.",
  },
  {
    slug: "de-antonio-d33-seea-one",
    name: "De Antonio D33",
    boatName: "Seea One",
    image: yachtDeantonio33,
    images: [yachtDeantonio33, yachtDeantonio33Aerial, yachtDeantonio33Lifestyle],
    length: "33 ft / 10 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "27 knots",
    crew: "Captain",
    features: "Spacious sunbeds, hidden outboard design",
    marina: "Marina Botafoc",
    pricing: { low: "€900", mid: "€1,100", high: "€1,350" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The De Antonio D33 stands out with bold styling and an innovative layout that maximizes deck space. Generous sunbathing areas and comfortable lounge seating create the perfect setting for relaxing with friends or family. Its sleek design and powerful performance ensure smooth cruising along the coast. Elegant finishes and contemporary design define the onboard experience.",
  },
  {
    slug: "de-antonio-d33-oceans",
    name: "De Antonio D33",
    boatName: "Oceans 911",
    image: yachtDeantonio33,
    images: [yachtDeantonio33, yachtDeantonio33Aerial, yachtDeantonio33Lifestyle],
    length: "33 ft / 10 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "27 knots",
    crew: "Captain",
    features: "Spacious sunbeds, hidden outboard design",
    marina: "Marina Botafoc",
    pricing: { low: "€900", mid: "€1,100", high: "€1,350" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description: "The De Antonio D33 stands out with bold styling and an innovative layout that maximizes deck space. Generous sunbathing areas and comfortable lounge seating create the perfect setting for relaxing with friends or family. Its sleek design and powerful performance ensure smooth cruising along the coast. Elegant finishes and contemporary design define the onboard experience.",
  },
  {
    slug: "kumbra-34-enjoy",
    name: "Kumbra 34",
    boatName: "Enjoy",
    image: yachtKumbra34Enjoy,
    images: [yachtKumbra34Enjoy, yachtKumbra34Aerial, yachtKumbra34Deck, yachtKumbra34Lifestyle],
    length: "34 ft / 10.4 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Wide sunbeds, relaxed seating, open deck",
    marina: "Port Nàutic",
    pricing: { low: "€1,000", mid: "€1,250", high: "€1,450" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 34 blends sleek styling with a comfortable and spacious layout, perfect for luxury day charters. Wide sunbeds and relaxed seating areas provide inviting spaces to unwind while cruising along the coast. Built with attention to detail and smooth performance, the boat ensures an enjoyable and stylish experience. The Kumbra 34 captures the spirit of relaxed luxury on the water.",
  },
  {
    slug: "kumbra-34-krabi",
    name: "Kumbra 34",
    boatName: "Krabi",
    image: yachtKumbra34Enjoy,
    images: [yachtKumbra34Enjoy, yachtKumbra34Aerial, yachtKumbra34Deck, yachtKumbra34Lifestyle],
    length: "34 ft / 10.4 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Wide sunbeds, relaxed seating, open deck",
    marina: "Port Nàutic",
    pricing: { low: "€1,000", mid: "€1,250", high: "€1,450" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 34 blends sleek styling with a comfortable and spacious layout, perfect for luxury day charters. Wide sunbeds and relaxed seating areas provide inviting spaces to unwind while cruising along the coast. Built with attention to detail and smooth performance, the boat ensures an enjoyable and stylish experience. The Kumbra 34 captures the spirit of relaxed luxury on the water.",
  },
  {
    slug: "kumbra-34-livia",
    name: "Kumbra 34",
    boatName: "Livia",
    image: yachtKumbra34Enjoy,
    images: [yachtKumbra34Enjoy, yachtKumbra34Aerial, yachtKumbra34Deck, yachtKumbra34Lifestyle],
    length: "34 ft / 10.4 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Wide sunbeds, relaxed seating, open deck",
    marina: "Port Nàutic",
    pricing: { low: "€1,050", mid: "€1,300", high: "€1,550" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 34 blends sleek styling with a comfortable and spacious layout, perfect for luxury day charters. Wide sunbeds and relaxed seating areas provide inviting spaces to unwind while cruising along the coast. Built with attention to detail and smooth performance, the boat ensures an enjoyable and stylish experience. The Kumbra 34 captures the spirit of relaxed luxury on the water.",
  },
  {
    slug: "kumbra-34-mila",
    name: "Kumbra 34",
    boatName: "Mila",
    image: yachtKumbra34Enjoy,
    images: [yachtKumbra34Enjoy, yachtKumbra34Aerial, yachtKumbra34Deck, yachtKumbra34Lifestyle],
    length: "34 ft / 10.4 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Wide sunbeds, relaxed seating, open deck",
    marina: "Port Nàutic",
    pricing: { low: "€1,050", mid: "€1,300", high: "€1,550" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 34 blends sleek styling with a comfortable and spacious layout, perfect for luxury day charters. Wide sunbeds and relaxed seating areas provide inviting spaces to unwind while cruising along the coast. Built with attention to detail and smooth performance, the boat ensures an enjoyable and stylish experience. The Kumbra 34 captures the spirit of relaxed luxury on the water.",
  },
  {
    slug: "kumbra-36",
    name: "Kumbra 36",
    boatName: "Moana",
    image: yachtKumbra36,
    images: [yachtKumbra36, yachtKumbra34Aerial, yachtKumbra34Lifestyle],
    length: "36 ft / 11 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "27 knots",
    crew: "Captain",
    features: "Sunbeds, lounge seating, open deck layout",
    marina: "Port Nàutic",
    pricing: { low: "€1,100", mid: "€1,350", high: "€1,600" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 36 offers a contemporary luxury boat charter experience with generous open deck space. Comfortable seating areas and sunbeds invite guests to relax while enjoying sweeping views of the sea. Clean lines and modern finishes create an elegant yet welcoming atmosphere on board. Designed for effortless cruising, the Kumbra 36 is ideal for stylish days on the water.",
  },
  {
    slug: "de-antonio-d36-tito",
    name: "De Antonio D36 Open",
    boatName: "Tito",
    image: yachtDeantonio36,
    images: [yachtDeantonio36, yachtDeantonio36Aerial, yachtDeantonio36Exterior],
    length: "36 ft / 11 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Hidden engines, sunbathing areas, spacious deck",
    marina: "Marina Botafoc",
    pricing: { low: "€1,100", mid: "€1,350", high: "€1,600" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The De Antonio D36 Open combines modern aesthetics with intelligent design to create a sophisticated luxury charter yacht. Its spacious deck layout includes elegant lounge seating, sunbeds, and inviting social areas. The sleek exterior profile reflects the innovative engineering behind its performance. Every detail of the D36 Open is crafted to deliver comfort, style, and effortless cruising.",
  },
  {
    slug: "de-antonio-d36-playyacht",
    name: "De Antonio D36 Open",
    boatName: "Playyacht IV",
    image: yachtDeantonio36,
    images: [yachtDeantonio36, yachtDeantonio36Aerial, yachtDeantonio36Exterior],
    length: "36 ft / 11 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Hidden engines, sunbathing areas, spacious deck",
    marina: "Marina Botafoc",
    pricing: { low: "€1,100", mid: "€1,350", high: "€1,600" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Paddle Surf", "Snorkels", "Beverages", "Towels"],
    description: "The De Antonio D36 Open combines modern aesthetics with intelligent design to create a sophisticated luxury charter yacht. Its spacious deck layout includes elegant lounge seating, sunbeds, and inviting social areas. The sleek exterior profile reflects the innovative engineering behind its performance. Every detail of the D36 Open is crafted to deliver comfort, style, and effortless cruising.",
  },
  {
    slug: "de-antonio-d36-jarvis",
    name: "De Antonio D36 Open",
    boatName: "Jarvis",
    image: yachtDeantonio36,
    images: [yachtDeantonio36, yachtDeantonio36Aerial, yachtDeantonio36Exterior],
    length: "36 ft / 11 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Hidden engines, sunbathing areas, spacious deck",
    marina: "Marina Botafoc",
    pricing: { low: "€1,100", mid: "€1,350", high: "€1,600" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Paddle Surf", "Snorkels", "Beverages", "Towels"],
    description: "The De Antonio D36 Open combines modern aesthetics with intelligent design to create a sophisticated luxury charter yacht. Its spacious deck layout includes elegant lounge seating, sunbeds, and inviting social areas. The sleek exterior profile reflects the innovative engineering behind its performance. Every detail of the D36 Open is crafted to deliver comfort, style, and effortless cruising.",
  },
  {
    slug: "de-antonio-d42",
    name: "De Antonio D42 Open",
    boatName: "Playyacht III",
    image: yachtDeantonio42,
    images: [yachtDeantonio42, yachtDeantonio42Hero, yachtDeantonio42Aerial],
    length: "42 ft / 12.6 m",
    guests: "Up to 12 guests",
    cabins: "2",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Hidden outboard engines, sunbathing areas, spacious deck",
    marina: "Botafoc / Port Nàutic",
    pricing: { low: "€1,300", mid: "€1,650", high: "€2,100" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The De Antonio D42 Open is a masterpiece of innovation and contemporary yacht design. Hidden outboard engines create a sleek silhouette while maximizing deck space for lounging and entertaining. Large sunbeds at the bow and stern invite guests to unwind under the sun while cruising the coastline. Stylish, spacious, and powerful, the D42 Open delivers a refined luxury day charter experience.",
  },
  {
    slug: "pardo-38",
    name: "Pardo 38",
    boatName: "Playyacht",
    image: yachtPardo38,
    images: [yachtPardo38, yachtPardo38Aerial, yachtPardo38Lifestyle, yachtPardo38Interior],
    length: "38 ft / 11.6 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Walkaround deck, bow sunbeds, shaded cockpit lounge",
    marina: "Marina Botafoc",
    pricing: { low: "€1,300", mid: "€1,550", high: "€1,800" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Pardo 38 offers a perfect balance between performance and understated luxury. Its walkaround deck layout creates easy access to generous seating areas and expansive sunbeds. Carefully selected materials and Italian craftsmanship elevate the onboard experience. Designed for stylish coastal cruising, the Pardo 38 delivers both elegance and comfort.",
  },
  {
    slug: "pardo-43",
    name: "Pardo 43",
    boatName: "Playyacht",
    image: yachtPardo43,
    images: [yachtPardo43, yachtPardo43Aerial, yachtPardo43Lifestyle, yachtPardo43Interior],
    length: "43 ft / 13 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "Captain",
    features: "Walkaround deck, large sunbeds, shaded lounge area, swim platform",
    marina: "Marina Botafoc",
    pricing: { low: "€1,450", mid: "€1,700", high: "€2,200" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Pardo 43 embodies modern luxury yachting, blending contemporary Italian design with timeless craftsmanship. Its signature walkaround deck offers effortless access to generous lounging and dining spaces. Elegant materials and clean design lines create a calm and refined onboard atmosphere. Perfect for stylish day charters, the Pardo 43 offers comfort, space, and exceptional cruising performance.",
  },
  {
    slug: "kumbra-43",
    name: "Kumbra 43",
    boatName: "Masalma",
    image: yachtKumbra43,
    length: "43 ft / 13 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Spacious deck layout, sunbathing areas, social lounge seating",
    marina: "Port Nàutic",
    pricing: { low: "€1,450", mid: "€1,700", high: "€2,200" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Towels", "Snorkels"],
    description: "The Kumbra 43 presents a bold and contemporary luxury boat charter experience defined by open space and elegant design. The expansive deck layout invites guests to relax, socialize, and enjoy panoramic ocean views. Comfortable lounge seating and generous sunbeds create the perfect setting for a stylish day at sea. Smooth performance and refined detailing make every journey aboard the Kumbra 43 effortlessly enjoyable.",
  },
  {
    slug: "pershing-54",
    name: "Pershing 54",
    boatName: "Torre del Canónigo",
    image: yachtPershing54,
    images: [yachtPershing54, yachtPershing54Exterior, yachtPershing54Aerial, yachtPershing54Stern],
    length: "54 ft / 16.5 m",
    guests: "Up to 10 guests",
    cabins: "2",
    cruisingSpeed: "32 knots",
    crew: "Captain",
    features: "Large sunbeds, luxury salon, swim platform, premium sound system",
    marina: "Marina Ibiza",
    pricing: { low: "€1,900", mid: "€2,250", high: "€2,750" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Paddle Surf", "Snorkels", "Beverages"],
    description: "The Pershing 54 is an icon of Italian luxury yacht design, combining sleek styling with thrilling performance. Its spacious aft deck and generous sunbeds create the perfect setting for relaxing in the sun or enjoying drinks while cruising. The interior lounge features elegant finishes and contemporary comfort. Ideal for a high-performance luxury yacht charter, the Pershing 54 offers both excitement and refined sophistication.",
  },
  {
    slug: "jaguar-72",
    name: "Jaguar 72",
    boatName: "Letty",
    image: yachtJaguar72,
    length: "72 ft / 22 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "25 knots",
    crew: "Captain + crew",
    features: "Sunbeds, outdoor lounge, swim platform, luxury interior salon",
    marina: "Marina Botafoc",
    pricing: { low: "€3,800", mid: "€4,500", high: "€5,000" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["2 Skippers", "Mooring", "Paddle Surf", "Snorkels", "Towels", "Beverages"],
    description: "The Jaguar 72 offers a truly exceptional luxury yacht charter experience, combining striking design with expansive living spaces. Wide teak decks create elegant outdoor lounges for sunbathing, dining, and entertaining while cruising along the coast. Inside, refined craftsmanship and spacious seating areas provide a calm and sophisticated retreat. With powerful performance and impressive stability, the Jaguar 72 delivers an unforgettable day of luxury on the water.",
  },
];

export const yachts: Yacht[] = [...arzaniFleet, ...charterFleet].sort(
  (a, b) => parsePrice(a.pricing.low) - parsePrice(b.pricing.low)
);
